import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';

const OutScopeError = () => {
    const headerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (headerRef.current !== null) {
            if (headerRef.current) {
                Object.assign(headerRef.current.style, {
                    width: '100vw',
                });
            }
        }
    }, []);
    return (
        <div className="flex flex-col h-screen">
            <Header ref={headerRef} />
            <Outlet />
        </div>
    );
};

export default OutScopeError;
